var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoBtnTinaco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_viviendas",
    transform: "translate(-306 -896)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6451",
    "data-name": "Rectangle 6451",
    width: 32,
    height: 32,
    transform: "translate(306 896)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8285",
    "data-name": "Group 8285",
    transform: "translate(311.151 897.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19958",
    "data-name": "Path 19958",
    d: "M166.93,99.234a29.515,29.515,0,0,1-8.132-1.163,2.841,2.841,0,0,1-2-2.755V79.43a2.833,2.833,0,0,1,1.2-2.357l4.374-3.061a.55.55,0,0,1,.294-.092h8.514a.482.482,0,0,1,.294.092l4.374,3.061a2.833,2.833,0,0,1,1.2,2.357V95.316a2.841,2.841,0,0,1-2,2.755,29.513,29.513,0,0,1-8.133,1.163ZM162.85,75.022l-4.228,2.969a1.741,1.741,0,0,0-.734,1.439V95.316A1.754,1.754,0,0,0,159.121,97,27.871,27.871,0,0,0,174.8,97a1.726,1.726,0,0,0,1.233-1.684V79.43a1.7,1.7,0,0,0-.734-1.439l-4.228-2.969Z",
    transform: "translate(-155.362 -70.524)",
    fill: "#021e43",
    stroke: "#021e43",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19959",
    "data-name": "Path 19959",
    d: "M270.092,37.066H259.386a.662.662,0,0,1-.664-.664V34.039a.676.676,0,0,1,.591-.664,44.491,44.491,0,0,1,10.853,0,.676.676,0,0,1,.591.664V36.4a.662.662,0,0,1-.665.664Zm-10.041-1.329h9.34v-1.07a43.892,43.892,0,0,0-9.34,0Z",
    transform: "translate(-253.423 -32.341)",
    fill: "#021e43",
    stroke: "#021e43",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19960",
    "data-name": "Path 19960",
    d: "M167.568,155.126h-.074c-1.144-.111-2.289-.221-3.433-.406a.669.669,0,0,1,.148-1.329c1.108.148,2.252.3,3.4.369a.666.666,0,0,1,.591.738.622.622,0,0,1-.628.628Z",
    transform: "translate(-161.588 -146.151)",
    fill: "#021e43",
    stroke: "#021e43",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19961",
    "data-name": "Path 19961",
    d: "M264.17,156.053c-1.809,0-3.618-.074-5.427-.185a.666.666,0,1,1,.074-1.329,88.888,88.888,0,0,0,16.871-.591.669.669,0,0,1,.148,1.329,87.622,87.622,0,0,1-11.666.775Z",
    transform: "translate(-255.21 -146.695)",
    fill: "#021e43",
    stroke: "#021e43",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19962",
    "data-name": "Path 19962",
    d: "M283.982,23.915a.679.679,0,0,1-.664-.628.7.7,0,0,1,.628-.738c.849-.074,1.661-.111,2.436-.148a.683.683,0,1,1,.037,1.366c-.775.037-1.514.074-2.363.148h-.074Z",
    transform: "translate(-275.739 -22.402)",
    fill: "#021e43",
    stroke: "#021e43",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19963",
    "data-name": "Path 19963",
    d: "M362.622,23.915h-.074c-.849-.074-1.624-.111-2.363-.148a.683.683,0,1,1,.037-1.366c.775.037,1.587.074,2.437.148a.723.723,0,0,1,.628.738.679.679,0,0,1-.665.628Z",
    transform: "translate(-348.053 -22.402)",
    fill: "#021e43",
    stroke: "#021e43",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19964",
    "data-name": "Path 19964",
    d: "M287.687,257.369a11.188,11.188,0,0,0-1.957-1.957,1.054,1.054,0,0,0-1.218,0l-.037.037a13.226,13.226,0,0,0-1.92,1.92,7.98,7.98,0,0,0-1.993,4.984,4.542,4.542,0,1,0,9.081,0,7.792,7.792,0,0,0-1.957-4.984Zm.7,4.947a3.25,3.25,0,1,1-6.5,0,6.675,6.675,0,0,1,1.735-4.135,11.947,11.947,0,0,1,1.551-1.587,12.815,12.815,0,0,1,1.551,1.587,7.083,7.083,0,0,1,1.661,4.135Z",
    transform: "translate(-273.771 -243.486)",
    fill: "#021e43",
    stroke: "#021e43",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19965",
    "data-name": "Path 19965",
    d: "M136.767,413.095h-1.292a.5.5,0,0,1-.517-.517v-2.141a.5.5,0,0,1,.517-.517h1.292a.517.517,0,1,1,0,1.034h-.775v1.108h.775a.5.5,0,0,1,.517.517.555.555,0,0,1-.517.517Z",
    transform: "translate(-134.958 -388.707)",
    fill: "#021e43",
    stroke: "#021e43",
    strokeWidth: 0.7
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBtnTinaco);
export default __webpack_public_path__ + "static/media/ico_btn_tinaco.17d13a7045600fa2c82cdcf452795e21.svg";
export { ForwardRef as ReactComponent };